import React from 'react';
import ContactBox from './ContactBox';
import ContactMsgBox from './ContactMsgBox';
function Contact () {
    return (  
        <div id='contact'>
            <div className='s-heading-div'>
            <div className='s-heading'>
        <h1>Contact us</h1>
      
      </div>
      <div className='b-container'>
            <ContactBox/>
            <ContactMsgBox/>
      </div>
        </div>
        </div>
    );
}
 
export default Contact;